"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStatusReturnsServicesToJSON = exports.CustomerStatusReturnsServicesFromJSONTyped = exports.CustomerStatusReturnsServicesFromJSON = void 0;
var _1 = require("./");
function CustomerStatusReturnsServicesFromJSON(json) {
    return CustomerStatusReturnsServicesFromJSONTyped(json, false);
}
exports.CustomerStatusReturnsServicesFromJSON = CustomerStatusReturnsServicesFromJSON;
function CustomerStatusReturnsServicesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'amount': (0, _1.AmountFromJSON)(json['amount']),
        'name': json['name'],
    };
}
exports.CustomerStatusReturnsServicesFromJSONTyped = CustomerStatusReturnsServicesFromJSONTyped;
function CustomerStatusReturnsServicesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'amount': (0, _1.AmountToJSON)(value.amount),
        'name': value.name,
    };
}
exports.CustomerStatusReturnsServicesToJSON = CustomerStatusReturnsServicesToJSON;
//# sourceMappingURL=CustomerStatusReturnsServices.js.map